export const query = `query getPosts($site: [String] = "default", $section: [String] = "posts", $relatedToSection: [String] = ["blogCategories", "blogTags", "blogAuthors"], $title: [String] = "", $id: [QueryArgument] = "not 1", $limit: Int = 9, $offset: Int = 0) {
  entryCount(
    site: $site
    section: $section
    type: "default"
    relatedToEntries: [{site: $site, section: $relatedToSection, title: $title}]
  )
  entries(
    site: $site
    section: $section
    type: "default"
    id: $id
    orderBy: "postDate DESC"
    relatedToEntries: [{site: $site, section: $relatedToSection, title: $title}]
    limit: $limit
    offset: $offset
  ) {
    id
    siteId
    siteHandle
    title
    slug
    uri
    url
    typeHandle
    ... on posts_default_Entry {
      tags: blogTags(limit: 2) {
        title
        slug
        url
      }
      blogFeaturedImage {
        format
        width
        height
        src: url
        alt: title
        title
      }
    }
    ... on posts_pillarPage_Entry {
      tags: blogTags(limit: 2) {
        title
        slug
        url
      }
      blogFeaturedImage {
        format
        width
        height
        src: url
        alt: title
        title
      }
    }
  }
}`;